// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"add-service-bin_routeHeader_1dWZ5","addButton":"add-service-bin_addButton_3fSkS"};